export default __webpack_public_path__ + "static/media/img1.77ff03f3.jpg";